import {
  OPEN_CONTACT_US_MODAL,
  CLOSE_CONTACT_US_MODAL,
  TOGGLE_TERMS_OF_SERVICES_MODAL,
  TOGGLE_FORGOT_PASSWORD_MODAL,
  TOGGLE_TUTORIAL_MODAL,
} from './types';

let initialState = {
  contactUsVisibility: false,
  termsOfServicesVisibility: false,
  forgotPasswordVisibility: false,
  tutorialVisibility: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OPEN_CONTACT_US_MODAL:
      return {
        ...state,
        contactUsVisibility: true,
      };
    case CLOSE_CONTACT_US_MODAL:
      return {
        ...state,
        contactUsVisibility: false,
      };
    case TOGGLE_TERMS_OF_SERVICES_MODAL:
      return {
        ...state,
        termsOfServicesVisibility: !state.termsOfServicesVisibility,
      };
    case TOGGLE_FORGOT_PASSWORD_MODAL:
      return {
        ...state,
        forgotPasswordVisibility: !state.forgotPasswordVisibility,
      };
    case TOGGLE_TUTORIAL_MODAL:
      return {
        ...state,
        tutorialVisibility: !state.tutorialVisibility,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/modals/reducer.js